import Model, { type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import { RI_BREAKDOWNS } from 'frontend-utils/utils/constants/constant-values';
import type { RevenueInsightSegmentationValue } from 'lumen/models';

type ChangeHasManyToArray<T> =
  T extends HasMany<RevenueInsightSegmentationValue>
    ? RevenueInsightSegmentationValue[]
    : T;

type KeysExcludingModel = keyof Omit<
  RevenueInsightBreakdownsRequest,
  keyof Model
>;

export type RevenueInsightBreakdownsRequestLike = {
  [K in KeysExcludingModel]: ChangeHasManyToArray<
    RevenueInsightBreakdownsRequest[K]
  >;
};

export default class RevenueInsightBreakdownsRequest extends Model {
  [Type] = 'revenue-insight/breakdowns-request' as const;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare booking_lead_time: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare cancellation_lead_time: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare company: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare guest_country: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare los: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare origin: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare rate_code: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare room_type: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare segment: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare source: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare source_profile: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare travel_agent: HasMany<RevenueInsightSegmentationValue>;

  @hasMany('revenue-insight/segmentation-value', {
    async: false,
    inverse: null,
  })
  declare weekday: HasMany<RevenueInsightSegmentationValue>;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get keys() {
    return Object.values(RI_BREAKDOWNS).filter(
      (key) => this[key as keyof typeof this] !== undefined,
    ) as (keyof Omit<RevenueInsightBreakdownsRequestLike, 'keys'>)[];
  }
}
